import script from "./Filelist.vue?vue&type=script&lang=ts&setup=true"
export * from "./Filelist.vue?vue&type=script&lang=ts&setup=true"

import "./Filelist.vue?vue&type=style&index=0&id=51fe7176&scoped=true&lang=less"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51fe7176"]])

export default __exports__